import React from 'react';
const kitItems = [{
  emoji: '🔄',
  title: 'Atlas de Adaptabilidad',
  desc: 'Regresiones para alumnos con lesiones y progresiones para alumnos avanzados. Nunca más te quedarás sin respuestas.'
}, {
  emoji: '🤲',
  title: 'Manual del Tacto Profesional',
  desc: 'Aprende exactamente dónde tocar y cómo asistir físicamente para que tus alumnos ganen rango en segundos.'
}, {
  emoji: '⚡',
  title: 'Diccionario de Micro-flujos',
  desc: 'Secuencias de "quitar y poner" para cuando tienes poco tiempo o necesitas un cambio de ritmo.'
}, {
  emoji: '🎯',
  title: 'Rutinas por Objetivo',
  desc: '"Escudo Lumbar", "Apertura de Escritorio", "Recuperación Post-Carrera". ¡Listas para aplicar!'
}];
export function KitTacticoSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-165">
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-secondary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-166"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-167">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-168">
          <span className="inline-flex items-center gap-2 bg-secondary/10 text-secondary font-black text-xs sm:text-sm px-4 py-1.5 rounded-full border border-secondary/20 mb-6 shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-169">
            🔥 INCLUIDO HOY
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-170">
            El Acelerador de Resultados:
            <br data-id="element-171" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-yellow-300" data-id="element-172">
              KIT TÁCTICO PRO
            </span>
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-173">
            Pasa de la teoría a la pista con tu{' '}
            <span className="text-text-main font-bold" data-id="element-174">
              "Caja de Herramientas"
            </span>{' '}
            de campo.
          </p>
        </div>

        {/* Intro paragraph */}
        <div className="bg-bg-alt/80 backdrop-blur-sm border border-border-light rounded-2xl p-6 sm:p-8 mb-10 text-center" data-id="element-175">
          <p className="text-text-sec text-base sm:text-lg leading-relaxed" data-id="element-176">
            Mientras que los Tomos te dan el conocimiento técnico, el Kit
            Táctico Pro es lo que usarás en el mat cada día. Es la diferencia
            entre un instructor que explica y un{' '}
            <span className="text-primary font-bold" data-id="element-177">
              Maestro que transforma
            </span>
            .
          </p>
        </div>

        {/* Kit items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-178">
          {kitItems.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 sm:p-8 flex flex-col gap-3 hover:-translate-y-1 transition-transform duration-300 group relative overflow-hidden" data-id="element-179">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-180"></div>

              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center text-2xl relative z-10 shadow-inner" data-id="element-181">
                {item.emoji}
              </div>
              <h3 className="text-xl font-bold text-text-main relative z-10" data-id="element-182">
                {item.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-base relative z-10" data-id="element-183">
                {item.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}